<!--
 * @Author: danteclericuzio
 * @Date: 2023-06-28 11:32:37
 * @Last Modified by: zhaoyang
 * @Last Modified time: 2025-07-04 16:37:24
-->

<template>
    <div class="tab ec-container">
        <div class="nav-wrap">
            <div
                v-for="(tab, index) in tabList"
                :key="index"
                :ref="tab.route.name"
                class="nav-itemwrap"
            >
                <div
                    v-if="tab.subRoutes"
                    class="nav-item"
                >
                    <div
                        v-for="(sub, idx) in tab.subRoutes"
                        :key="idx"
                        :ref="sub.name"
                        class="nav-content"
                        :class="{ 'router-link-exact-active': isActiveLink(sub.name) }"
                        :style="{ 'width': `calc(100% / ${tab.subRoutes.length})`}"
                    >
                        <router-link :to="{name: sub.name}">
                            <span :class="{'anchor-nav-active': sub.name === $route.name}">
                                {{ $t(sub.name.toUpperCase()) }}
                            </span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="tab-content">
            <slot />
        </div>
    </div>
</template>

<script>
import {routeMap} from 'easycash/common/router/routes';

export default {
    name: 'Tab',

    title() {
        return this.$t(this.$route.name.toUpperCase());
    },

    computed: {
        tabList() {
            const {path} = this.$route;
            const isAbout = /^\/about\/us.*/.test(path);

            return isAbout ? [
                {
                    route: routeMap.us,
                    subRoutes: [
                        routeMap.operation,
                        routeMap.management,
                        routeMap.finacicalReport,
                        routeMap.publicationComplaint
                    ]
                }
            ] : [{
                route: routeMap.faq,
                subRoutes: [
                    routeMap.faqGeneral,
                    routeMap.faqBorrow,
                    routeMap.faqLend,
                    routeMap.faqBeware,
                    routeMap.faqLapsSjk
                ]
            }];
        }
    },

    methods: {
        isActiveLink(linkName) {
            return this.$route.name === linkName;
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .tab {
        display: flex;
        min-height: 70vh;
        display: flex;
        flex-direction: column;
        padding-bottom: 0.5rem;

        @media screen and (max-width: $screen-md) {
            padding-top: 0.2rem;
        }

        .nav-wrap {
            background-color: #ebeef1;
            height: 0.4rem;
            border-radius: 0.2rem;
            margin-top: 0.2rem;
            margin-bottom: 0.4rem;
            text-align: center;

            .nav-itemwrap {
                .nav-item {
                    display: flex;
                    height: 0.4rem;

                    .nav-content {
                        width: calc(100% / 5);

                        &:not(.router-link-exact-active):hover {
                            background-color: white;
                            border-radius: 0.2rem;
                            height: 100%;
                        }
                    }
                }
            }

            @media screen and (max-width: $screen-md) {
                display: none;
            }
        }

        .nav-itemwrap .nav-content a.router-link-exact-active span {
            color: white;
            font-weight: 700 !important;
        }

        .nav-itemwrap .nav-content a span {
            color: black;
            font-weight: 400 !important;
        }

        .nav-itemwrap .nav-content.router-link-exact-active {
            background-color: #090909;
            border-radius: 0.2rem;
            height: 100%;
        }

        a {
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            font-size: 0.18rem;
            line-height: 0.18rem;
            font-style: normal;
            height: 0.4rem;

            span {
                flex: 1;
                padding: 0.1rem;
            }
        }
    }
</style>
